import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import LocalStorage from 'utils/LocalStorage';

import Logo from 'static/img/logo.svg';
import LogoSM from 'static/img/logo-sm.svg';
import LogoWorld from 'static/img/world.svg';
import LanguageEn from 'languages/en';
import LanguageEs from 'languages/es'

import './Header.css';

declare var CONFIGURATIONS;

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      langSelected: LocalStorage.getString('language') || 'es',
    };
  }

  // componentDidMount = () => {
  //   let url = CONFIGURATIONS.configgeneral.urlgeoportal;
  //   this.setState({ ...this.state, url: url });
  // }

  changeLanguage = (lang) => {
    this.setState({ langSelected: lang }, () => {
      LocalStorage.putString('language', lang);
      window.location.reload();
    });
  }

  navigate = () => {
    window.location.href = `${process.env.PUBLIC_URL}/inicio`;
  }

  render() {
    const { langSelected } = this.state;
    const urlTerminoses = CONFIGURATIONS.configgeneral.urlTerminoses;
    const urlTerminosen = CONFIGURATIONS.configgeneral.urlTerminosen;
    const urlAboutes = CONFIGURATIONS.configgeneral.urlAboutes;
    const urlAbouten = CONFIGURATIONS.configgeneral.urlAbouten;
    const urlPortales = CONFIGURATIONS.configgeneral.urlgeoportal;
    const urlPortalen = CONFIGURATIONS.configgeneral.urlgeoportalen;

    return (<Fragment>
      <header>
        <div className="row">
          <div className="col-left">
            <img src={Logo} className="logo-lg img-responsive" alt="Logo" />
            <img src={LogoSM} className="logo-sm img-responsive" alt="Logo" />
          </div>
          <div className="col-right">
            <a href={langSelected === 'es' ? urlTerminoses : urlTerminosen} className="term-acerca" alt={langSelected === 'es' ? LanguageEs.visor.termycondition : LanguageEn.visor.termycondition} target="_blank" rel="noopener noreferrer">
              <span> {langSelected === 'es' ? LanguageEs.visor.termycondition : LanguageEn.visor.termycondition} </span>
            </a>
            <a href={langSelected === 'es' ? urlAboutes : urlAbouten} className="term-acerca" alt={langSelected === 'es' ? LanguageEs.visor.about : LanguageEn.visor.about} target="_blank" rel="noopener noreferrer">
              <span> {langSelected === 'es' ? LanguageEs.visor.about : LanguageEn.visor.about} </span>
            </a>
            <a href={langSelected === 'es' ? urlPortales : urlPortalen} className="link-to-portal" alt="Link Portal IdeIHM" target="_blank" rel="noopener noreferrer">
              <img src={LogoWorld} className="img-responsive" alt="Logo World" />
              <span>{langSelected === 'es' ? LanguageEs.visor.portal : LanguageEn.visor.portal}</span>
            </a>
            <div className='visor-language'>
              <span className={langSelected === 'es' ? 'lang-selected' : 'lang-option'}
                onClick={this.changeLanguage.bind(null, 'es')}>es</span>
              <span className={langSelected === 'en' ? 'lang-selected' : 'lang-option'}
                onClick={this.changeLanguage.bind(null, 'en')}>en</span>
            </div>
          </div>
        </div>
      </header>
    </Fragment>);
  }
}

// export default translate()(Header);
export default withTranslation()(Header);
